<template>
    <svg class="h-5 w-5 no-color" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
      <path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 18h3.75a5.25 5.25 0 100-10.5H5M7.5 4L4 7.5 7.5 11"/>
    </svg>
</template>

<script>
export default {
  name: 'undoIcon'
}
</script>
